import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiBookOpen, FiEdit3, FiEye, FiSave, FiVideo } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData, formatDateOnly } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";


const ContentTable = () => {
  const [saveData, setSaveData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
const[pageSize,setPageSize]=useState(10)
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  
  const buildFormData = (page = 1) => {
    const formData = new FormData();

    formData.append("page", page);
formData.append("per_page",pageSize)
    return formData;
  };

  const fetchAllData = async (page = 1) => {
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const formData = buildFormData(page);
      const result = await fetchFormData("content/list", formData, "POST");

      const apiData = result?.result?.data || result?.data ||[]

      if (apiData) {
        setSaveData(apiData.data || []);
        setCurrentPage(apiData.current_page || 1);
        setLastPage(apiData.last_page || 1);
      } else {
        setSaveData([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("id", Id);

    const result = await fetchFormData(`toggle-status`, formData, "POST");

    if (result?.success || result?.code === 200) {
      await fetchAllData(currentPage);

      const newStatus = Number(result.data.status);

      topTost({
        title:
          newStatus === 1
            ? "Status updated successfully: Active"
            : "Status updated successfully: Deactive",
        icon: "success",
      });
    } else {
      console.error("Failed to toggle status:", result?.message);
      topTost({
        title: "Status update failed!",
        icon: "error",
      });
    }
  };

  const columns = [
    {
      accessorKey: "actions",
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
        const is_active = Number(row.original.status);

        return (
          <div className="hstack gap-3 justify-content-end">
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/content/view/${id}`)}
              title="Content View"
            >
              <FiEye size={16} />
            </span>
            <span
              className="cursor-pointer"
              title="Edit"
              onClick={() => navigate(`/master/edit-topic/${id}`)}
            >
              <FiEdit3 size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/edit-notes/${id}`)}
              title="Edit Notes"
            >
              <FiBookOpen size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/edit-pdf/${id}`)}
              title="Edit Pdf"
            >
              <FiSave size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/edit-video/${id}`)}
              title="Edit Video"
            >
              <FiVideo size={16} />
            </span>
            {is_active === 1 ? (
              <MdThumbUp
                className="cursor-pointer text-success"
                onClick={() => toggleStatus(id)}
              />
            ) : (
              <MdThumbDown
                className="cursor-pointer text-secondary"
                onClick={() => toggleStatus(id)}
              />
            )}
          </div>
        );
      },

      meta: {
        headerClassName: "width-30",
        exportable: false,
      },
    },

    {
      accessorKey: "course_name",
      header: () => "course",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "semester_name",
      header: () => "semester",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "subject_name",
      header: () => "subject name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "chapter_name",
      header: () => "chapter name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "title",
      header: () => "title",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    
    {
      accessorKey: "created_at",
      header: () => "created at",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchAllData(1);
  }, [pageSize]);
  return (
    <>
    
      <Table
        columns={columns}
        data={saveData}
        serverSide={true}
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={(page) => fetchAllData(page)}
      pageSize={pageSize}
  setPageSize={setPageSize}
      />
    </>
  );
};

export default ContentTable;
